import type { CallRequest, CreateCallRequest } from '../outgoing-webhooks/call-request.interface';
import { CALL_STATUS } from '../outgoing-webhooks/call-request.interface';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class CallRequestFactory extends ObjectFactory<CallRequest> {
  protected getDefaults(): CallRequest {
    return {
      ...baseDocumentFactory.build(),
      calls: [],
      correlationId: 'correlation-id',
      incomingEventId: 'incoming-event-id',
      nextCallDate: null,
      processingTimeout: null,
      status: CALL_STATUS.TODO,
      webhookConfigId: 'webhook-config-id',
    };
  }

  /** Build a CreateCallRequest body (no base document fields). */
  buildCreate(overrides: Partial<CreateCallRequest> = {}): CreateCallRequest {
    return {
      calls: [],
      correlationId: 'correlation-id',
      incomingEventId: 'incoming-event-id',
      nextCallDate: null,
      processingTimeout: null,
      status: CALL_STATUS.TODO,
      webhookConfigId: 'webhook-config-id',
      ...overrides,
    };
  }
}

export const callRequestFactory = new CallRequestFactory();
